export const statusColors = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
] as const;

export type StatusColor = (typeof statusColors)[number];

export const statusColorNames: Record<StatusColor, string> = {
    A: 'PINK',
    B: 'ORANGE',
    C: 'SUN',
    D: 'TURQUOISE',
    E: 'LIME',
    F: 'LIGHT_BLUE',
    G: 'LILAC',
    H: 'LIGHT_GREY',
    I: 'GREY',
    J: 'SALMON',
    K: 'ZINC',
    L: 'ACID',
    M: 'CERULEAN',
    N: 'LACE',
    O: 'LAVENDER',
};

export function toStatusColor(
    code: string | undefined | null,
): StatusColor | undefined {
    if (!code) return undefined;
    return statusColors.find((c) => c === code.toUpperCase());
}
